<template>
  <div class="content">
    <div class="holder container">
      <div class="content-body col-md-7 col-11 p-0">
        <div class="form-group row-text-index">
          <span class="font-weight-bold">{{$t('front_end.a080.order_number')}} : {{realOrderNo}}</span>
        </div>
        <div class="form-group message-group">
          <p class="message">{{$t('front_end.a080.message_first_unusual')}}</p>
          <p class="message mb-0">{{$t('front_end.a080.message_middle_unusual_a')}}</p>
          <p class="message text-danger">{{$t('front_end.a080.message_middle_unusual_b')}}</p>
          <p class="message">{{$t('front_end.a080.message_bottom_unusual')}}</p>
        </div>
      </div>
      <form :action="exportUrl" method="POST" ref="formExport">
        <input type="hidden" name="data" :value="dataParams" />
      </form>
      <div class="content-footer-payment">
        <button
          class="col-md-4 col-7 btn-footer"
          @click="redirectToA125()"
        >{{$t('front_end.a080.button_back_confirm')}}</button>
      </div>
      <div class="content-footer-payment">
        <button
          class="col-md-4 col-7 btn-footer"
          @click="showAlert()"
        >{{$t('front_end.a080.button_clear_data')}}</button>
      </div>
    </div>
    <fe-alert :datas="dataAlert" ref="modalConfirm">
      <template v-slot:default>
        <div class="form-group text-center cursor-default content-box">{{ dataAlert.content }}</div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          @click="onModalConfirmYes"
          class="btn-dialog col-6 border-top border-right"
        >{{ dataAlert.confirmText }}</button>
        <button
          type="button"
          @click="onModalConfirmCancel"
          class="btn-dialog col-6 border-top border-left"
        >{{ dataAlert.dismissText }}</button>
      </template>
    </fe-alert>
  </div>
</template>

<script>
import FeAlert from "@/components/fe/common/FeAlert";
import apiService from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";


export default {
  name: "a090",
  components: {
    FeAlert
  },
  data() {
    return {
      realOrderNo:"",
      orderNo: this.$route.params.orderNo,
      dataParams: {},
      exportUrl: "",
      dataAlert: {
        content: this.$t("front_end.a090.alert.confirm_to_delete"),
        confirmText: this.$t("front_end.a060.yes"),
        dismissText: this.$t("front_end.a060.cancel"),
        isShow: true,
        showCenterDevice: true,
        modalStyle: {
          overflow: "unset"
        }
      }
    };
  },
  async created() {
     this.realOrderNo = await this.getOrderNo();
  },
  methods: {
    redirectToA125() {
      this.$router.push({ name: "a125" });
    },
    showAlert() {
      this.$refs.modalConfirm.show();
    },
    deleteOrder() {
      // TODO: Delete data in localStorage or VueX
      this.clearSession();
      this.$router.push({ name: "a005" });
    },
    clearSession() {
      //TODO CLEAR DATA REORDER, ORDER CONFIRM IMAGE
      this.$store.dispatch("userData/clearSession");
      localStorage.setItem("personal_address", "[]");

      sessionStorage.setItem("ed", "{}");

      this.$store.dispatch("userData/clearSession");
      this.$store.dispatch("reOrder/clearSession");
      this.$store.dispatch("userData/clearSessionReOrder");
      this.$store.dispatch("userData/clearSessionTemplate");
    },
    onModalConfirmCancel() {
      this.$refs.modalConfirm.hide();
    },
    onModalConfirmYes() {
      this.$refs.modalConfirm.hide();
      this.deleteOrder();
    },
    async getOrderNo(){
      let {data}  =  await apiService.post(apiEndpoints.getOrderNo, {
        orderNo: this.orderNo,
        settlementResult:"error"
      });
      let {orderNo} = data || {};
      return orderNo;
    }
  }
};
</script>
<style scoped src='../../assets/css/completePayment/completePayment.css'></style>
<style scoped>
.content-box {
  margin-top: 15px;
}
</style>
